import { Tooltip, TooltipContent, TooltipTrigger } from "@shared/ui/tooltip";
import { HelpCircle } from "lucide-react";
import React from "react";

type ValueLabelProps = {
  label?: React.ReactNode;
  value?: string | null | React.ReactNode;
  description?: string | null;
  layout?: "vertical" | "horizontal";
  className?: string;
  tooltip?: string;
  icon?: React.ReactNode;
  isHoverable?: boolean;
};

export const ValueLabel: React.FC<ValueLabelProps> = ({
  label,
  value,
  description,
  layout = "vertical",
  className = "",
  tooltip,
  icon,
  isHoverable = false,
}) => {
  const wrapperClasses = "flex items-start gap-3";
  const contentClasses =
    layout === "horizontal"
      ? "flex items-center gap-2"
      : "flex flex-col gap-0.5";

  return (
    <div className={`${wrapperClasses} ${className}`}>
      {icon && <span className="flex-shrink-0">{icon}</span>}
      <div className={contentClasses}>
        <div className="flex items-center gap-1">
          <p className="text-xs text-muted-foreground tracking-wide leading-none font-medium">
            {label ?? "NA"}
          </p>
          {tooltip && (
            <Tooltip>
              <TooltipTrigger asChild>
                <HelpCircle className="h-3.5 w-3.5 text-gray-400 flex-shrink-0" />
              </TooltipTrigger>
              <TooltipContent>
                <p className="max-w-xs">{tooltip}</p>
              </TooltipContent>
            </Tooltip>
          )}
        </div>
        {isHoverable ? (
          <Tooltip>
            <TooltipTrigger asChild>
              <p className="text-sm font-medium text-foreground truncate cursor-default">
                {value ?? "NA"}
              </p>
            </TooltipTrigger>
            <TooltipContent>
              <p className="max-w-xs">{value ?? "NA"}</p>
            </TooltipContent>
          </Tooltip>
        ) : (
          <p className="text-sm font-medium text-foreground">{value ?? "NA"}</p>
        )}
        {description && (
          <p className="text-xs text-muted-foreground">{description}</p>
        )}
      </div>
    </div>
  );
};
